import { envConfig } from "config/envConfig"

export const Version = () => {
	return <div>{envConfig.commitSHA()}</div>
}
